module.exports = __webpack_public_path__ + "static/media/tables.b4ce680b.md";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Tables/tables.md
// module id = 216
// module chunks = 0